import { variables } from "oddsgate-ds";
import styled from "styled-components";

export const StyledHelloBar = styled.div`
  width: 100%;
  padding: 0.5rem 1.25rem;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.25rem;
  font-size: 15px;
  overflow: hidden;
  z-index: 1000;
  position: relative;

  .style-light & {
    background: ${variables.colors.third50};
    color: ${variables.colors.secondary50};
  }

  .style-dark & {
    background: ${variables.colors.secondary50};
    color: ${variables.colors.third50};
  }
`;

export const StyledHelloBarContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.25rem;
  flex-grow: 1;
  @media only screen and (max-width: ${variables.responsiveMedia}) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const StyledHelloBarText = styled.div``;

export const StyledHelloBarLink = styled.a`
  text-decoration: underline;
  cursor: pointer;

  .style-light & {
    color: ${variables.colors.secondary50};
  }

  .style-dark & {
    color: ${variables.colors.third50};
  }
  &:hover {
    opacity: 0.8;
  }
`;

export const StyledHelloBarCloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  cursor: pointer;

  .style-light & {
    color: ${variables.colors.secondary50};
  }

  .style-dark & {
    color: ${variables.colors.third50};
  }
  &:hover {
    opacity: 0.8;
  }
  @media only screen and (max-width: ${variables.responsiveMedia}) {
    align-self: flex-start;
  }
`;

export const StyledHelloBarSeparator = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  .style-light & {
    background: ${variables.colors.secondary50};
  }

  .style-dark & {
    background: ${variables.colors.primary50};
  }
  @media only screen and (max-width: ${variables.responsiveMedia}) {
    width: 4px;
    height: 4px;
  }
`;
